// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iOqFx","icon":"Button_icon__5EAcg","label":"Button_label__CZ42Y"};